import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import { Link, Text } from '@/components/common'
import TryFreeCta from '@/components/TryFreeCta'
import routes from '@/routes'

import styles from './Hero.module.scss'

const avatarImages = ['/home2/trust1.webp', '/home2/trust2.webp', '/home2/trust3.webp']
const starIndexes = [1, 2, 3, 4, 5]

export default function Hero({ t }) {
  return (
    <section className={styles.hero}>
      <div className={styles.gridBg} />

      {/* Decorative rectangles - left side */}
      <div className={styles.decoLeft}>
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
      </div>

      {/* Decorative rectangles - right side */}
      <div className={styles.decoRight}>
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
        <div className={styles.decoRect} />
      </div>

      <div className={styles.inner}>
        {/* Social proof row */}
        <div className={styles.socialProof}>
          <div className={styles.avatars}>
            {avatarImages.map((avatar, index) => (
              <div key={avatar} className={styles.avatarWrap}>
                <Image
                  alt={`Neat User Trust ${index + 1}`}
                  className={styles.avatar}
                  height={36}
                  src={avatar}
                  width={36}
                />
              </div>
            ))}
          </div>
          <div className={styles.stars}>
            {starIndexes.map((star) => (
              <Image
                key={`hero-star-${star}`}
                alt="star"
                height={14}
                src="/home2/star-icon.svg"
                width={15}
              />
            ))}
          </div>
          <Text className={styles.reviewsText}>{t.reviews}</Text>
        </div>

        {/* Headline */}
        <Text.H1 className={styles.title}>{t.title}</Text.H1>

        {/* Subtitle */}
        <Text.P className={styles.subtitle}>{t.subtitle}</Text.P>

        {/* CTA Buttons */}
        <div className={styles.ctaRow}>
          <TryFreeCta buttonMessageId={null} className={styles.ctaPrimary} size="xlTall">{t.ctaPrimary}</TryFreeCta>
          <Link className={styles.ctaSecondary} size="xlTall" to={routes.neatFeatures} variant="secondary">
            <span className={styles.ctaSecondaryLabel}>
              {t.ctaSecondary}
              <Image
                alt=""
                className={styles.ctaArrow}
                height={16}
                src="/home2/arrow-right.svg"
                width={16}
              />
            </span>
          </Link>
        </div>

        <Text className={styles.price} onTint>{t.price}</Text>

        {/* Hero image */}
        <div className={styles.imageWrapper}>
          <Image
            alt="Neat App Interface"
            className={styles.heroImage}
            height={750}
            priority
            src="/home2/hero-1.webp"
            width={1200}
          />
          <div className={styles.heroImageOverlay} />
        </div>
      </div>
    </section>
  )
}

Hero.propTypes = {
  t: PropTypes.shape({
    reviews: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    ctaPrimary: PropTypes.string.isRequired,
    ctaSecondary: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
  }).isRequired,
}
